import React from 'react';
import { AGENTS } from '../context/AgentContext';

const STATUS_COLORS = {
  completed: '#10b981',
  running: '#3b82f6',
  failed: '#ef4444',
  pending: '#374151',
};

const STATUS_BG = {
  completed: 'rgba(16, 185, 129, 0.1)',
  running: 'rgba(59, 130, 246, 0.15)',
  failed: 'rgba(239, 68, 68, 0.1)',
  pending: 'rgba(55, 65, 81, 0.3)',
};

const STATUS_ICONS = {
  completed: '\u2713',
  running: '\u25CF',
  failed: '\u2717',
  pending: '\u25CB',
};

const AgentPipeline = ({ pipeline, selectedAgent, onSelectAgent }) => {
  if (!pipeline) return null;

  return (
    <div className="agent-pipeline">
      {AGENTS.map((agent, i) => {
        const status = pipeline[agent.id]?.status || 'pending';
        const color = STATUS_COLORS[status];
        const isSelected = selectedAgent === agent.id;
        const isRunning = status === 'running';

        return (
          <React.Fragment key={agent.id}>
            {i > 0 && (
              <div className="agent-pipeline__arrow" style={{
                color: pipeline[AGENTS[i - 1].id]?.status === 'completed' ? '#10b981' : '#374151'
              }}>
                <svg width="20" height="12" viewBox="0 0 20 12">
                  <path d="M0 6h16M12 1l5 5-5 5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            )}
            <button
              className={`agent-pipeline__segment ${isSelected ? 'agent-pipeline__segment--selected' : ''} ${isRunning ? 'agent-pipeline__segment--running' : ''}`}
              onClick={() => onSelectAgent(agent.id)}
              style={{
                borderColor: isSelected ? color : 'transparent',
                background: STATUS_BG[status],
              }}
            >
              <span className="agent-pipeline__icon" style={{ color }}>
                {STATUS_ICONS[status]}
              </span>
              <span className="agent-pipeline__label">{agent.label}</span>
              <span className="agent-pipeline__status" style={{ color }}>
                {status}
              </span>
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default AgentPipeline;
